import { CustomerProject } from '../customer-project.interface';
import { Status } from '../status.interface';
import { User } from '../user.interface';
import { ChatMessage } from './chat-message.interface';
import { ChatUser } from './chat-user.interface';

export class Chat {
    id?: number;
    name: string;
    chat_users?: ChatUser[] = [];
    chatMessages?: ChatMessage[];
    creator?: User;
    lastMessage?: ChatMessage;
    lastReadMessageIndex?: number;
    updated_at?: Date;
    created_at?: Date;
    type: string;
    lng?: number;
    lat?: number;
    customer_project_id: number;
    customer_project?: CustomerProject;
    status?: Status;
    status_id?: number;
}
